import { render, staticRenderFns } from "./descrizioniPolize.vue?vue&type=template&id=2b0e65c9&"
import script from "./descrizioniPolize.vue.ts?vue&type=script&lang=ts&"
export * from "./descrizioniPolize.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports